import BaseService from './../../base'

class AccountService extends BaseService {
  // 创建账号
  async createAccountApi (postData) {
    return this.post('/admin/account', postData);
  }

  // 重置账号密码为默认密码
  async resetPasswordApi (id) {
    return this.patch(`/admin/account/reset_password/${id}`);
  }

  // 删除账号
  async deleteAccountApi (id) {
    return this.delete(`/admin/account/${id}`);
  }

  // 修改账号数据
  async updateAccountApi (id, data) {
    return this.patch(`/admin/account/${id}`, data);
  }

  // 账号修改密码
  async modifyPasswordApi (params) {
    return await this.patch('/admin/account/modify_password', params);
  }

  // 根据账号获取已经授权的角色
  async accountRoleListApi (accountId) {
    return await this.get(`/admin/account_role/${accountId}`);
  }

  // 获取账号列表
  async accountListApi (params = {}) {
    return await this.get('/admin/account', params);
  }

  // // 根据条件查询到第一条数据
  // async searchApi (params) {
  //   return await this.post('admin/account/search', params);
  // }

  // // 根据账号id获取账号信息
  // async accountByIdApi (id) {
  //   return await this.get(`admin/account/${id}`);
  // }
}

export default new AccountService()
